import PropTypes from 'prop-types';
import React from 'react';

import { SelectInput } from 'Shared/form/SelectField';

const options = [
    { value: undefined, label: 'All' },
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
];

const MobileQuestionsFilter = ({ column: { filterValue, setFilter } }) => {
    return (
        <SelectInput
            name="mobileEnabledQuestions"
            aria-label="Mobile-Enabled Questions"
            value={options.find((o) => o.value === filterValue)}
            onChange={(opt) => setFilter(opt.value)}
            options={options}
        />
    );
};
MobileQuestionsFilter.propTypes = {
    column: PropTypes.shape({
        filterValue: PropTypes.bool,
        setFilter: PropTypes.func,
    }).isRequired,
};

export default MobileQuestionsFilter;
